"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IFrame = /** @class */ (function () {
    function IFrame(src) {
        var _this = this;
        this.loaded = false;
        this.waiting = [];
        var iframe = document.createElement('IFRAME');
        var html = document.querySelector('html');
        iframe.onload = function () { return _this.frameIsLoaded(iframe); };
        iframe.style.position = 'absolute';
        iframe.style.left = '-20em';
        iframe.id = 'auth-cage';
        iframe.src = src;
        html.appendChild(iframe);
    }
    IFrame.prototype.set = function (key, data) {
        this.sendToCage({ key: key, data: data, action: 'set' });
    };
    IFrame.prototype.get = function (key) {
        this.sendToCage({ key: key, action: 'get' });
    };
    IFrame.prototype.remove = function (key) {
        this.sendToCage({ key: key, action: 'remove' });
    };
    IFrame.prototype.clear = function () {
        this.sendToCage({ key: 'null', action: 'clear' });
    };
    IFrame.prototype.frameIsLoaded = function (iframe) {
        this.loaded = true;
        this.cage = iframe.contentWindow;
        this.waiting.forEach(function (callback) { return callback(); });
    };
    IFrame.prototype.onceLoaded = function (callback) {
        if (this.loaded) {
            callback();
        }
        else {
            this.waiting.push(callback);
        }
    };
    IFrame.prototype.sendToCage = function (payload) {
        var _this = this;
        this.onceLoaded(function () {
            _this.cage.postMessage(JSON.stringify(payload), '*');
        });
    };
    return IFrame;
}());
exports.default = IFrame;
